import { CheckCircle2 } from 'lucide-react'
import type { Category } from '@/types'
import { clsx } from 'clsx'

interface Props {
  categories: Category[]
  currentIndex: number
  completedBefore: number
  onNavigate: (index: number) => void
}

export function StepNav({ categories, currentIndex, completedBefore, onNavigate }: Props) {
  return (
    <div className="flex gap-2 overflow-x-auto pb-1 mb-6">
      {categories.map((cat, i) => {
        const isDone = i < completedBefore
        const isCurrent = i === currentIndex
        return (
          <button
            key={cat.id}
            onClick={() => i <= completedBefore && onNavigate(i)}
            className={clsx(
              'flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm whitespace-nowrap transition-colors shrink-0',
              isCurrent
                ? 'bg-brand-500 text-white font-semibold'
                : isDone
                ? 'bg-brand-100 text-brand-700 hover:bg-brand-200 cursor-pointer'
                : 'bg-slate-100 text-slate-400 cursor-default'
            )}
          >
            {isDone && <CheckCircle2 className="h-3.5 w-3.5 shrink-0" />}
            {cat.name}
          </button>
        )
      })}
    </div>
  )
}
